export type NestedListDataType = {
    label: string;
    key: string | number;
    content?: NestedListDataType[];
};

type NestedListType = {
    data: NestedListDataType[];
};

const NestedList = ({ data }: NestedListType) => {
    return (
        <ul>
            {data.map(({ content, key, label }) => (
                <li key={key} title={label}>
                    <span>{label}</span>
                    {content && content.length > 0 && (
                        <NestedList data={content} />
                    )}
                </li>
            ))}
        </ul>
    );
};

export default NestedList;
